<template>

    <svg v-svg
        class="icon"
        role="presentation"
        :style="styles"
        :symbol="symbol"
        :size="width && height ? `0 0 ${width} ${height}` : `0 0 ${size} ${size}`">
    </svg>

</template>

<style scoped lang="scss">

    .icon {
        background: transparent;
        display: inline-block;
        line-height: 0;
        margin: 0;
        overflow: hidden;
        padding: 0;
    }

    .dark-mode .icon {
        filter: invert(100%);
    }

</style>

<script>

export default {

    props: {
        symbol: {
            type: String,
            required: true,
        },
        size: {
            type: Number,
            default: 100,
        },
        width: {
            type: Number,
        },
        height: {
            type: Number,
        },
        radius: {
            type: Number,
            default: 0,
        },
        scale: {
            type: Number,
            default: 1,
        },
    },

    computed: {

        styles() {
            return {
                'border-radius': `${this.radius}px`,
                'width': this.width * this.scale || this.size * this.scale,
                'height': this.height * this.scale || this.size * this.scale,
            };
        },

    },

}

</script>
